<template>
  <div ref="navbar" class="navbar">
    <div class="bar" :class="{primary: $route.name !== 'Main', hide: isHideTopNavbar}">
      <button class="hamburger-button" @click="isOpenMenuPanel = !isOpenMenuPanel">
        <img :src="util.getImagePath('menu_white@2x.png')" :srcset="util.getImageSet('menu_white')">
      </button>
      <button class="logo-button split" v-if="$route.name !== 'Main'" @click="clickLogoButton">
        <img :src="util.getImagePath(`promptpai_logo_${$i18n.locale}@2x.png`)" :srcset="util.getImageSet(`promptpai_logo_${$i18n.locale}`)">
      </button>
      <button class="map-button" v-if="$route.name === 'Main'" @click="$router.push('/map/myplace/@13.764955,100.538317,6,1,0')">
        <!-- <img :src="util.getImagePath('map_white@2x.png')" :srcset="util.getImageSet('map_white')"> -->
        {{ $t('NavBar.map') }}
      </button>
      <button class="map-button" v-if="$route.name !== 'Main'" @click="$router.push('/')">
        <!-- <img :src="util.getImagePath('home_white@2x.png')" :srcset="util.getImageSet('home_white')"> -->
        {{ $t('NavBar.main') }}
      </button>
    </div>
    <div class="backdrop" ref="backdrop" v-show="isOpenMenuPanel" @click="isOpenMenuPanel = !isOpenMenuPanel">
    </div>
    <transition name="menu-panel-animation">
      <div class="menu-panel" v-show="isOpenMenuPanel">
        <div class="user-info-container" :class="{authenticated: isAuthenticated}">
          <img :src="profileImagePath" :srcset="profileImageSet">
          <button class="login-button" @click="clickLoginButton" v-if="!isAuthenticated">{{ $t('NavBar.login') }}</button>
          <label class="display-name" v-if="isAuthenticated">{{ displayName }}</label>
          <label class="fullname" v-if="isAuthenticated">{{ fullname }}</label>
        </div>
        <div class="menu-list-container">
          <div style="display: flex; flex-direction: row;">
            <div class="language-mode-container">
              <input id="th-language-mode" name="language-mode" type="radio" @change="changeLanguageMode('th')" :checked="$i18n.locale === 'th'" />
              <label for="th-language-mode">{{ 'th' }}</label>
              <input id="en-language-mode" name="language-mode" type="radio" @change="changeLanguageMode('en')" :checked="$i18n.locale === 'en'" />
              <label for="en-language-mode">{{ 'en' }}</label>
            </div>
            <!-- <button class="menu-button line-app" @click="clickLine">
              <img :src="util.getImagePath('line@2x.png')" :srcset="util.getImageSet('line')">
            </button>
            <button class="menu-button facebook-app" @click="clickFacebook">
              <img :src="util.getImagePath('share_facebook@2x.png')" :srcset="util.getImageSet('share_facebook')">
            </button> -->
          </div>
          <div class="line"></div>
          <button class="menu-button scan-qr" @click="clickScanQr">
            <img :src="util.getImagePath('icon_scan_qr_orange@2x.png')" :srcset="util.getImageSet('icon_scan_qr_orange')">
            <label>{{ $t('NavBar.scanQr') }}</label>
          </button>
          <a href="/map/create" class="menu-button create-place" @click="clickCreatePlace">
            <img :src="util.getImagePath('icon_add_pin_orange@2x.png')" :srcset="util.getImageSet('icon_add_pin_orange')">
            <label>{{ $t(`NavBar.createPlace`) }}</label>
          </a>
          <div class="line"></div>
          <button class="menu-button my-qr" v-if="isAuthenticated" @click="clickMyQr">
            <img :src="util.getImagePath('icon_qr_blue@2x.png')" :srcset="util.getImageSet('icon_qr_blue')">
            <label>{{ $t('NavBar.myQr') }}</label>
          </button>
          <button class="menu-button my-place" @click="clickMyPlace">
            <img :src="util.getImagePath('icon_place_blue@2x.png')" :srcset="util.getImageSet('icon_place_blue')">
            <!-- <label>{{ $t(`NavBar.${isMyPlaces ? 'myPlace' : 'bestPlace'}`) }}</label> -->
            <label>{{ $t(`NavBar.myPlace`) }}</label>
          </button>
          <button class="menu-button received-place-list" v-if="isAuthenticated" @click="clickReceivedPlaceList">
            <img :src="util.getImagePath('icon_noti_blue@2x.png')" :srcset="util.getImageSet('icon_noti_blue')">
            <label style="display: flex; flex-direction: row; align-items: center; text-align: left; width: 100%;}">
              {{ $t('NavBar.receivedPlace') }}
              <div class="number-new-noti" v-show="numberNewNoti > 0">{{ numberNewNoti }}</div>
            </label>
          </button>
          <div class="line"></div>

          <!-- <button class="menu-button received-place-list" v-if="isAuthenticated" @click="clickPdpaManagement">
            <img :src="util.getImagePath('icon_privacy_blue@2x.png')" :srcset="util.getImageSet('icon_privacy_blue')">
            <label>{{ $t('NavBar.pdpaManagement') }}</label>
          </button> -->
          <a href="https://longdo.com/en/user/17180/edit/Privacy" class="menu-button received-place-list" v-if="isAuthenticated" @click="clickPdpaManagement">
            <img :src="util.getImagePath('icon_privacy_blue@2x.png')" :srcset="util.getImageSet('icon_privacy_blue')">
            <label>{{ $t(`NavBar.pdpaManagement`) }}</label>
          </a>
          <div class="line" v-if="isAuthenticated"></div>

          <a href="/about" class="menu-button about" @click="clickAbout">
            <img :src="util.getImagePath('icon_about_blue@2x.png')" :srcset="util.getImageSet('icon_about_blue')">
            <label>{{ $t(`NavBar.about`) }}</label>
          </a>

          <a href="/privacy" class="menu-button privacy" @click="clickPrivacy">
            <img :src="util.getImagePath('icon_privacy_blue@2x.png')" :srcset="util.getImageSet('icon_privacy_blue')">
            <label>{{ $t(`NavBar.privacy`) }}</label>
          </a>

          <a href="/ws" class="menu-button dev" @click="clickDev">
            <img :src="util.getImagePath('icon_develop_blue@2x.png')" :srcset="util.getImageSet('icon_develop_blue')">
            <label>{{ $t(`NavBar.dev`) }}</label>
          </a>

          <div class="line"></div>
          <div class="follow">
            <label>{{ $t(`NavBar.follow`) }}</label>
            <a href="https://lin.ee/tdLwtpH" class="menu-button line-app" @click="clickLine">
              <img :src="util.getImagePath('line@2x.png')" :srcset="util.getImageSet('line')">
            </a>
            <a href="https://www.facebook.com/promptpainow" class="menu-button facebook-app" @click="clickFacebook">
              <img :src="util.getImagePath('share_facebook@2x.png')" :srcset="util.getImageSet('share_facebook')">
            </a>
          </div>
        </div>
        <button class="menu-button logout" v-if="isAuthenticated" @click="clickLogoutButton">
          <img :src="util.getImagePath('logout_blue@2x.png')" :srcset="util.getImageSet('logout_blue')">
          <label>{{ $t('NavBar.logout') }}</label>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'Main',
  data () {
    return {
      isOpenMenuPanel: false,
      isAuthenticated: false,
      profileImagePath: '',
      profileImageSet: '',
      displayName: '',
      fullname: '',
      isMyPlaces: false,
      numberNewNoti: 0,
      isHideTopNavbar: false,
      isLockNavbar: false
    }
  },
  mounted () {
    var self = this
    self.profileImagePath = self.util.getImagePath('user_profile_blue@2x.png')
    self.profileImageSet = self.util.getImageSet('user_profile_blue')
    self.$root.$on('updateNumberReceivedLocation', self.updateNumberReceivedLocation)
    self.$root.$on('showNavbar', self.showNavbar)
    self.$root.$on('hideNavbar', self.hideNavbar)
    self.$root.$on('hideTopNavbar', self.hideTopNavbar)
    self.$root.$on('showTopNavbar', self.showTopNavbar)
    self.$root.$on('logout', self.clickLogoutButton)
  },
  methods: {
    updateNumberReceivedLocation (number) {
      var self = this
      self.numberNewNoti = Number(number)
      var userAgent = self.util.getUserAgentMeta()
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.updateBadgeNoti?n=${self.numberNewNoti}`
      }
    },
    showNavbar () {
      var self = this
      self.isOpenMenuPanel = true
    },
    hideNavbar () {
      var self = this
      self.isOpenMenuPanel = false
    },
    hideTopNavbar (lock) {
      var self = this
      if (lock === undefined && !self.isLockNavbar) {
        self.isHideTopNavbar = true
      } else if (lock !== undefined) {
        self.isHideTopNavbar = true
        self.isLockNavbar = lock
      }
    },
    showTopNavbar (lock) {
      var self = this
      if (lock === undefined && !self.isLockNavbar) {
        self.isHideTopNavbar = false
      } else if (lock !== undefined) {
        self.isHideTopNavbar = false
        self.isLockNavbar = lock
      }
    },
    changeLanguageMode (language) {
      var self = this
      self.$i18n.locale = language
    },
    clickFacebook (e) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      self.isOpenMenuPanel = false
      var url = `https://www.facebook.com/promptpainow`
      window.gtag('config', 'UA-143787399-1', {
        'page_path': url
      })
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    },
    clickLine (e) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      self.isOpenMenuPanel = false
      var url = `https://lin.ee/tdLwtpH`
      window.gtag('config', 'UA-143787399-1', {
        'page_path': url
      })
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    },
    clickLogoButton () {
      var self = this
      self.isOpenMenuPanel = false
      self.$router.push('/')
    },
    clickLoginButton () {
      var self = this
      self.isOpenMenuPanel = false
      self.$root.$emit('openModal', {
        name: 'Login'
      })
    },
    clickMyQr () {
      var self = this
      self.isOpenMenuPanel = false
      self.$root.$emit('openModal', {
        name: 'MyQrCard'
      })
    },
    clickMyPlace () {
      var self = this
      self.isOpenMenuPanel = false
      self.$router.push('/map/myplace/@13.764955,100.538317,12,1,0?my_place_tab=Favorite')
    },
    clickReceivedPlaceList () {
      var self = this
      self.isOpenMenuPanel = false
      self.$root.$emit('openModal', {
        name: 'ReceivedPlaceList'
      })
    },
    clickScanQr () {
      var self = this
      self.isOpenMenuPanel = false
      self.$root.$emit('openModal', {
        name: 'QrReader'
      })
    },
    clickCreatePlace (e) {
      e.preventDefault()
      var self = this
      self.isOpenMenuPanel = false
      self.$router.push('/map/create')
      return false
    },
    clickPdpaManagement (e) {
      e.preventDefault()
      var self = this
      self.isOpenMenuPanel = false
      // self.$root.$emit('openModal', {
      //   name: 'PdpaManagement'
      // })
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://longdo.com/${self.$i18n.locale}/user/${JSON.parse(self.getPromptPaiCookies('UserProfile')).uid}/edit/Privacy`
      if (userAgent === 'iOS application') {
        window.location.href = url
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    },
    clickAbout (e) {
      e.preventDefault()
      var self = this
      self.isOpenMenuPanel = false
      self.$router.push('/about')
      return false
    },
    clickPrivacy (e) {
      e.preventDefault()
      var self = this
      self.isOpenMenuPanel = false
      self.$router.push('/privacy')
      return false
    },
    clickDev (e) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      self.isOpenMenuPanel = false
      window.gtag('config', 'UA-143787399-1', {
        'page_path': '/ws'
      })
      var url = `${window.location.origin}/ws`
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    },
    clickSettingLanguage () {
      var self = this
      self.isOpenMenuPanel = false
      self.$root.$emit('openModal', {
        name: 'SettingLanguage'
      })
    },
    clickLogoutButton (forceReload = true) {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.isOpenMenuPanel = false
      self.setPromptPaiCookies('isAuthenticated', JSON.stringify(false), Infinity, '/')
      self.removePromptPaiCookies('UserProfile', '/')
      self.pp.registerFcmToken(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        isAuthenticated ? undefined : uuid,
        '',
        JSON.parse(self.getPromptPaiCookies('deviceId')),
        undefined,
        (result) => {
          if (result.status.code === 200) {
            self.resetMyPlaceStore()
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
          if (forceReload) {
            self.$router.go(0)
          } else {
            self.setRecentList(undefined)
            self.setRecentPage(1)
            self.setFavoriteList(undefined)
            self.setFavoritePage(1)
          }
        }
      )
    },
    myPlace () {
      // var self = this
      // var userProfile = {}
      // var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      // var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      // if (isAuthenticated) {
      //   userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
      //   uuid = undefined
      // }
      // self.pp.getFavoritePlaces(
      //   'name' in userProfile ? userProfile.name : undefined,
      //   'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
      //   isAuthenticated ? undefined : uuid,
      //   0,
      //   undefined,
      //   undefined,
      //   (result) => {
      //     if (result.status.code === 200) {
      //       self.isMyPlaces = result.is_myplaces
      //     } else if (result.status.code === 403) {
      //     } else {
      //     }
      //   }
      // )
    }
  },
  watch: {
    '$route' (newRoute, oldRoute) {
      var self = this
      self.$nextTick(() => {
        if (newRoute.hash === '#min') {
          setTimeout(() => {
            self.hideTopNavbar()
          }, 100)
        }
      })
    },
    isOpenMenuPanel () {
      var self = this
      if (self.isOpenMenuPanel) {
        document.querySelectorAll('.navbar > *').forEach(element => {
          element.style.zIndex = '1000'
        })
        self.$nextTick(() => {
          var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
          if (isAuthenticated) {
            var userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
            userProfile.profile_firstname = userProfile.profile_firstname !== null ? userProfile.profile_firstname : ''
            userProfile.profile_lastname = userProfile.profile_lastname !== null ? userProfile.profile_lastname : ''
            self.displayName = userProfile.display_name
            self.fullname = `${userProfile.profile_firstname} ${userProfile.profile_lastname}`
            self.profileImagePath = userProfile.profile_picture_fullpath
            self.profileImageSet = ''
          } else {
            self.profileImagePath = self.util.getImagePath('user_profile_blue@2x.png')
            self.profileImageSet = self.util.getImageSet('user_profile_blue')
          }
          self.isAuthenticated = isAuthenticated
          self.myPlace()
        })
      } else {
        document.querySelectorAll('.navbar > *').forEach(element => {
          element.style.zIndex = '500'
        })
      }
    }
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('updateNumberReceivedLocatioff')
    self.$root.$off('showNavbar')
    self.$root.$off('hideNavbar')
    self.$root.$off('hideTopNavbar')
    self.$root.$off('showTopNavbar')
  }
}
</script>

<style scoped>
  .navbar > * {
    z-index: 500;
    position: absolute;
    width: 100%;
  }

  .bar {
    height: 40px;
    background-color: transparent;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .bar.primary {
    background-color: rgba(34, 84, 156, 0.9);
  }

  .bar > .split {
    margin-right: auto;
  }

  .hamburger-button {
    height: 32px;
    width: 32px;
    padding: 0px;
    margin: 4px;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    background-color: transparent;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(34, 84, 156);
  }

  .hamburger-button > img {
    width: 24px;
    height: 24px;
  }

  .logo-button {
    height: 32px;
    padding: 0px;
    margin: 4px;
    cursor: pointer;
    border: none;
    background-color: transparent;
    overflow: hidden;
  }

  .logo-button > img {
    max-height: 100%;
  }

  .map-button {
    height: 32px;
    padding: 0px 16px;
    margin: 4px 12px 4px 4px;
    cursor: pointer;
    border: none;
    background-color: transparent;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(255, 255, 255);
    font-family: Prompt;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 4px;
    font-size: 16px;
    background-color: rgb(34, 84, 156);
  }

  .map-button > img {
    width: 24px;
    height: 24px;
  }

  .language-mode-container {
    display: flex;
    flex-direction: row;
    margin: 16px;
  }

  .language-mode-container label {
    cursor: pointer;
    padding: 0px 8px;
    height: 24px;
    color: rgb(163,163,163);
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Prompt;
    font-size: 16px;
    background-color: rgb(232,232,232);
  }

  .language-mode-container label[for="th-language-mode"] {
    border-radius: 4px 0px 0px 4px;
  }

  .language-mode-container label[for="en-language-mode"] {
    border-radius: 0px 4px 4px 0px;
  }

  .language-mode-container input {
    display: none;
  }

  .language-mode-container input:checked + label {
    background-color: rgb(30, 82, 158);
    color: rgb(255, 255, 255);
  }

  .backdrop {
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;
  }

  .menu-panel-animation-enter-active, .menu-panel-animation-leave-active {
    transition: all 0.5s;
  }
  .menu-panel-animation-enter {
    opacity: 0;
    transform: translateX(-400px);
  }
  .menu-panel-animation-leave-to {
    opacity: 0;
    transform: translateX(-400px);
  }

  .menu-panel {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 400px;
    height: 100%;
    background-color: rgb(251, 251, 251);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.5);
    -webkit-appearance: none;
    display: flex;
    flex-direction: column;
  }

  .user-info-container {
    background-image: linear-gradient(-180deg, #478dcb, #22549c);
    padding: 16px;
    display: flex;
    flex-direction: row;
  }

  .user-info-container.authenticated {
    flex-direction: column;
  }

  .user-info-container > img {
    width: 48px;
    height: 48px;
    border-radius: 24px;
    /* overflow: hidden; */
    background-color: rgb(251, 251, 251);
    object-fit: cover;
  }

  .user-info-container > label.display-name {
    color: rgb(255, 255, 255);
    font-size: 18px;
    margin: 8px 0px 0px 0px;
    line-height: 1.5;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .user-info-container > label.fullname {
    color: rgb(255, 255, 255);
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
  }

  .login-button {
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 16px;
    background-color: transparent;
    cursor: pointer;
    font-size: 18px;
    color: rgb(255, 255, 255);
    height: 48px;
    font-family: Prompt;
  }

  .menu-list-container {
    /* display: flex;
    flex-direction: column; */
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
    -webkit-appearance: none;
    height: calc(100% - 130px - 4px - 48px);
    margin-bottom: 4px;
    overflow-y: auto;
  }

  .menu-list-container::-webkit-scrollbar-button {
    height: 1px;
  }
  .menu-list-container::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .menu-list-container::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  .menu-button {
    width: 100%;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 16px;
    background-color: rgb(251, 251, 251);
    cursor: pointer;
    box-sizing: border-box;
    text-decoration: none;
  }

  .follow {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .follow > label {
    font-family: Prompt;
    margin: 12px 16px 12px 16px;
    font-size: 16px;
  }

  .menu-button.facebook-app,
  .menu-button.line-app {
    width: 24px;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 16px 12px 0px;
    background-color: rgb(251, 251, 251);
    cursor: pointer;
    box-sizing: content-box;
  }

  .menu-button.line-app {
    /* margin-left: auto; */
  }

  .menu-button > img {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

  .menu-button > label {
    font-size: 16px;
    cursor: pointer;
    font-family: Prompt;
    text-align: left;
  }

  .number-new-noti {
    flex-direction: row;
    background-color: red;
    padding: 0px 8px;
    border-radius: 10px;
    color: rgb(255, 255, 255);
    justify-content: center;
    align-items: center;
    margin-left: auto;
  }

  .line {
    width: 100%;
    height: 1px;
    background-color: rgb(215, 215, 215);
  }

  .menu-button.logout > label {
    color: rgb(34, 84, 156);
    font-weight: bold;
  }

  @media only screen and (max-width: 768px) {
    .bar {
      transition: margin-top 0.5s ease 0s, opacity 0.5s ease 0s;
    }

    .bar.hide {
      opacity: 0;
      margin-top: -40px;
    }
  }

  @media only screen and (max-width: 480px) {
    .menu-panel {
      width: calc(100% - 60px);
    }
  }

  @media only screen and (max-width: 320px) {
    .language-mode-container label {
      font-size: 14px;
    }

    .menu-button > label {
      font-size: 14px;
    }

    .follow > label {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue